import type { SVGAttributes } from "react";

/**
 * Spinner — indicateur de chargement inline.
 *
 * SVG inline animé via `animate-spin` Tailwind. La couleur du trait suit
 * `currentColor` : on hérite donc de `text-*` du parent (ex. `text-champagne-700`).
 */
export interface SpinnerProps extends Omit<SVGAttributes<SVGSVGElement>, "size"> {
  /** Taille : `sm` (16px) / `md` (24px) / `lg` (40px). Défaut `md`. */
  size?: "sm" | "md" | "lg";
  /** Libellé accessible (défaut "Chargement…"). */
  label?: string;
}

const SIZE_PX: Record<NonNullable<SpinnerProps["size"]>, number> = {
  sm: 16,
  md: 24,
  lg: 40,
};

export function Spinner({
  size = "md",
  label = "Chargement…",
  className = "",
  ...rest
}: SpinnerProps) {
  const px = SIZE_PX[size];
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label={label}
      className={["animate-spin", className].filter(Boolean).join(" ")}
      {...rest}
    >
      {/* Cercle de fond très léger */}
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
      {/* Arc actif qui tourne */}
      <path
        d="M12 2a10 10 0 0 1 10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
